const OfferName = ({ props }) => {
    const { name, settings } = props;

    if (!name) {
        return;
    }

    let style = null;

    if (settings?.maxLines) {
        style = {
            WebkitLineClamp: settings.maxLines,
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        };
    }

    return (
        <div class="l-ss-c-offer-title"
                 style={style}>
            {name}
        </div>
    );
};

OfferName.props = {
    name: {
        type: String,
    },
    settings: {
        type: Object,
    },
};

export default OfferName;
